<div>
    <h1 mat-dialog-title>Have you checked?</h1>
    <div mat-dialog-content>
        Have you changed or removed this short URL from all the pages that have it?
    </div>
    <div mat-dialog-actions align="end">
        <button mat-button class="primary" (click)="seePages()">See Pages</button>
        <button mat-button (click)="archivedIt()" cdkFocusInitial >Yes</button> 
    </div>
</div>